import { createFileRoute } from '@tanstack/react-router';

import { PracticeMembersPage } from '@/pages/practice-members';

export const Route = createFileRoute('/practice-members')({
    component: PracticeMembersPage,
});
